export const isNotEmpty = (object: Object) => {
  return Object.keys(object).length !== 0 && object.constructor === Object;
};

export const getIdsFromArray = (array: any) => {
  return array.map((item: any) => item.id);
};
